import { BlockModule } from '../common'
import { createApp, defineComponent, defineAsyncComponent } from 'vue'
import { addDotBtnsAndClickHandlers, addPrevNextBtnsClickHandlers } from '../embla' 
import { swup } from '@/lib/swup'

new BlockModule({
    selector: '.block-hero-carousel-banner',
    async setupBlock(el, onTeardown) {
        const globalSearchForm = el.querySelector('.global-search-form') as HTMLFormElement
        const globalSearchPageUrl = el.getAttribute('data-search-page-base-url')
        
        const handleFormSubmit = (e: Event) => {
            e.preventDefault()
            if (!globalSearchForm || !globalSearchPageUrl) return
            const searchInput = globalSearchForm.querySelector('input[type=search]') as HTMLInputElement
            if (searchInput) {       
                swup.navigate(`${globalSearchPageUrl}?searchTerm=${searchInput.value}`)
            }
        }

        globalSearchForm?.addEventListener('submit', handleFormSubmit)

        const importantNoticeEl = el.querySelector('.important-notice-vue-app')

        if (importantNoticeEl) {
            const importantNoticeVueApp = createApp(
                defineComponent({
                    name: 'important-notice-vue-app',
                    components: {
                        CollapsibleRoot: defineAsyncComponent(
                            () => import('radix-vue').then(x => x.CollapsibleRoot)
                        ),
                        CollapsibleContent: defineAsyncComponent(
                            () => import('radix-vue').then(x => x.CollapsibleContent)
                        ),
                        CollapsibleTrigger: defineAsyncComponent(
                            () => import('radix-vue').then(x => x.CollapsibleTrigger)
                        ),
                    },
                }),
            )

            importantNoticeVueApp.mount(importantNoticeEl)

            onTeardown(() => {
                importantNoticeVueApp.unmount()
            })
        }

        const swiperContainer = el.querySelector('.swiper') as HTMLElement
        
        if (!swiperContainer) return

        const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide')) as HTMLElement[] || []

        if (slides.length <= 1) return

        const [{ Swiper }, { Navigation, Pagination }] = await Promise.all([
            import('swiper'),
            import('swiper/modules'),
            // @ts-ignore
            import('swiper/css'),
            // @ts-ignore
            // import('swiper/css/autoplay'),
            // import('swiper/css/pagination'),
        ])

        const swiper = new Swiper(swiperContainer, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            // autoplay: {
            //     delay: 3000  
            // },
            navigation: {
                prevEl: swiperContainer.querySelector('.swiper-button-prev') as HTMLElement,
                nextEl: swiperContainer.querySelector('.swiper-button-next') as HTMLElement,
            },
            pagination: {
                el: swiperContainer.querySelector('.swiper-bullets') as HTMLElement,
                clickable: true,
                bulletElement: 'button',
                bulletClass: 'rounded-full transition-all duration-300 ease-in size-3 bg-slate-200 dark:bg-midGrey',
                bulletActiveClass: '!w-9 !bg-primary dark:!bg-slate-200'
            }
        })

        
    
        onTeardown(() => {
            globalSearchForm?.removeEventListener('submit', handleFormSubmit)
            swiper.destroy()
            // removeDotBtnsAndClickHandlers()
            // removePrevNextBtnsClickHandlers()
            // emblaApi.destroy()
        })
    },
})

